import React from 'react';
import cn from 'classnames';
import bottomLogoText from 'src/assets/bottom-logo-text.svg';
import twoLinesLogo from 'src/assets/two-lines-logo.svg';
import { usePortraitPairCycle } from 'src/hooks/use-portrait-pair-cycle';
import { Portrait, PortraitGroups } from 'src/utils/pick-portrait-pair';

import css from './Main.module.scss';

interface Props {
  portraits?: PortraitGroups;
}

function Face({
  side,
  current,
  incoming,
  isTransitioning,
}: {
  side: 'left' | 'right';
  current?: Portrait;
  incoming?: Portrait;
  isTransitioning: boolean;
}) {
  const shouldSwap = Boolean(isTransitioning && incoming && incoming !== current);

  return (
    <div className={cn(css.face, css[side])}>
      <div className={css.stage}>
        {current && (
          <img key={`${side}-${current}`} className={cn(css.portrait, shouldSwap && css.exit)} src={current} alt="" />
        )}
        {shouldSwap && incoming && (
          <img key={`${side}-${incoming}`} className={cn(css.portrait, css.enter)} src={incoming} alt="" />
        )}
      </div>
    </div>
  );
}

export default function Intro({ portraits }: Props) {
  const title = 'בדקו עם מי יש לכם';
  const bottomP1 = `מתלבטים בין שתי מפלגות? לכל זוג התאמנו 10 אמירות בנושאים שבהם מצאנו פערים ביניהן. סמנו אם אתם בעד או נגד כל אמירה וגלו איזו מפלגה קרובה יותר לעמדות שלכם • הפרויקט בשיתוף עמותת 121`;
  const bottomP2 = 'התוצאה משקפת התאמה בעמדות שנבדקו, ולא המלצה למי להצביע';
  const { pair, incoming, isTransitioning } = usePortraitPairCycle(portraits);

  return (
    <>
      <div className={css.intro}>
        <div className={css.introTop}>
          <Face side="left" current={pair?.left} incoming={incoming?.left} isTransitioning={isTransitioning} />
          <h1 className={css.texts}>
            <span>{title}</span>
            <img src={twoLinesLogo} alt="" />
            <img src={bottomLogoText} alt="" />
          </h1>
          <Face side="right" current={pair?.right} incoming={incoming?.right} isTransitioning={isTransitioning} />
        </div>
      </div>
      <div className={css.bottomTexts}>
        <p className={css.p1}>{bottomP1}</p>
        <p className={css.p2}>{bottomP2}</p>
      </div>
    </>
  );
}
